import { render, staticRenderFns } from "./MealFeedbackForm.vue?vue&type=template&id=6d475508&scoped=true&"
import script from "./MealFeedbackForm.vue?vue&type=script&lang=js&"
export * from "./MealFeedbackForm.vue?vue&type=script&lang=js&"
import style0 from "./MealFeedbackForm.vue?vue&type=style&index=0&id=6d475508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d475508",
  null
  
)

export default component.exports